import { useState, useEffect } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import * as Fields from '../../lis-layout/components/lis-forms-component';
import { Link } from 'react-router-dom';
import { isDevTenant, houseDomains, legislativeDomains, senateDomains, msalConfig, HOUSE_AUTHORITY } from "../../../authConfig";
import { clearMsalStorage } from "../../../services/request.service";

const NewLoginForm = (props) => {

    const [errorMessage, setErrorMessage] = useState('');
    const { instance, accounts } = useMsal();
    const [userPrincipalName, setUsername] = useState('')
    const [isHouse, toggleIsHouse] = useState(false);

    useEffect(() => {
        toggleIsHouse(houseDomains.includes(userPrincipalName?.split('@').at(-1).toLowerCase()));
    }, [userPrincipalName]);

    const translateLoginHint = (value) => {
        if (!value) return "";

        const input = value.trim().toLowerCase().replaceAll('+', '');

        if (input.endsWith("@dlasva.onmicrosoft.com")) {
            return input;
        }

        if (!input.includes("@")) {
            return input;
        }

        const parts = input.split("@");
        if (parts.length !== 2) {
            return input;
        }

        const localPart = parts[0];
        const domainPart = parts[1];
        if (isDevTenant) {
            return `${localPart}#${domainPart}@dlasva.onmicrosoft.com`;
        } else {
            if (legislativeDomains.includes(domainPart)) {
                return `${localPart}@azuredlasvirginia.onmicrosoft.com`;
            } else if (senateDomains.includes(domainPart)) {
                return input;
            }
            else {
                return `${localPart}#${domainPart}@azuredlasvirginia.onmicrosoft.com`;
            }
        }
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        clearMsalStorage()
        if (isHouse) {
            try {
                setErrorMessage("");
                const houseRequest = { ...msalConfig };
                delete houseRequest.clientId;
                houseRequest.authority = HOUSE_AUTHORITY;
                const loginResponse = await instance.loginRedirect({
                    ...houseRequest,
                    loginHint: userPrincipalName
                });
            } catch (error) {
                console.error("Login failed:", error);
                setErrorMessage(error instanceof Error ? error.message : "Login failed.");
            }
        } else {
            try {
                setErrorMessage("");
                const translatedLoginHint = translateLoginHint(userPrincipalName);
                const loginResponse = await instance.loginRedirect({
                    ...msalConfig,
                    loginHint: translatedLoginHint || undefined
                });
            } catch (error) {
                console.error("Login failed:", error);
                setErrorMessage(error instanceof Error ? error.message : "Login failed.");
            }
        }
    };

    const { isSubmenu } = props;

    // smallest email domain is 4 characters. x @ uk
    // 1 char, at, 2 chars
    let canLogin = userPrincipalName?.includes('@') && userPrincipalName.indexOf('@') < userPrincipalName.length - 4 &&
        userPrincipalName.includes('.') && userPrincipalName.indexOf('.') < userPrincipalName.length - 2;

    return <div className={!isSubmenu ? "inner-grid two multi-row" : ""}>
        <div className="dlas-forms full-login-form pkce">
            <form onSubmit={handleLogin}>
                <div>
                    <div className="single-row">
                        {isSubmenu
                            ? <span className="bold txt-blue">Log In to LIS</span>
                            : <h3>Log In to LIS</h3>}
                    </div>
                    <div className="single-row">
                        <Fields.TextInput
                            id="userId"
                            autoFocus={true}
                            type="text"
                            placeholder="Email"
                            value={userPrincipalName}
                            onChange={e => setUsername(e.target.value)}
                        />
                    </div>
                    <div className="single-row" style={!isSubmenu ? { marginTop: "10px" } : {}}>
                        <button className="button secondary" type="submit" disabled={!userPrincipalName || !canLogin}>Login</button>
                    </div>
                    {errorMessage}
                </div>
            </form>
            {isSubmenu && <hr className="faded-line full-width" />}
            <div className="flex-row" style={!isSubmenu ? { marginTop: "10px" } : {}}>
                <Link to='/forgot-password' >Forgot Password</Link>
                <Link to="/register-account">Register Account</Link>
            </div>
        </div>
        {!isSubmenu &&
            <div className="txt-blue">
                <h3><b>Track up to 5 bills for free</b></h3>
                <p>Your new free account will allow you to track up to 5 bills in one Watchlist and set up notifications.</p>
                <p>Email notification triggers an email when bills are sponsored by a member of the General Assembly, referred to a House or Senate Committee or contain a specific key word(s), phrases, or Code section(s).</p>

                <h3><b>Lobbyist-in-a-Box Subscription</b></h3>
                <p>A subscription to Lobbyist-in-a-Box offers up to 100 Watchlists (previously called "Profiles") containing 300 bills each.</p>
                <p>The cost of this service is $400 per user for state agencies, and $600 per user for all other subscribers.  More user accounts can be added, please refer to the Subscription Information on the <a style={{ textDecoration: "none" }} target="_blank" rel="noreferrer" href="http://help.lis.virginia.gov/liab/index.asp">LIS Learning Center</a> for additional options and fees, the 2-Step Registration and Payment process, and complete LIAB registration instructions.</p>
                <p><span className="bold">Need additional information or assistance?</span> Please send an e-mail message to <a style={{ textDecoration: "none" }} href="mailto:lis@dlas.virginia.gov">lis@dlas.virginia.gov</a>.</p>
                <p>For questions relating to LIAB Subscription payment procedures, please contact Virginia Interactive, LLC (VI) dba Tyler Virginia at <a style={{ textDecoration: "none" }} href="mailto:va-customerservice@tylertech.com">va-customerservice@tylertech.com</a> or (804) 318-4133.</p>
            </div>
        }
    </div>
}

export default NewLoginForm;
